import { refundClient } from "@/refund/clients";
import { Api } from "./refund/v1/refund-v1-api";

const api = new Api({ customFetch: refundClient, baseUrl: `https://api.${process.env.REACT_APP_DOMAIN || ""}` });

export default api;
